export const updateClientWindowSize = (context, payload) => {
  context.commit("updateClientWindowSize", payload);
};

export const updateDark = (context, payload) => {
  context.commit("updateDark", payload);
};

export const updateMini = (context, payload) => {
  context.commit("updateMini", payload);
};

export const updateDeclinedPWA = (context, payload) => {
  context.commit("updateDeclinedPWA", payload);
};

export const updateInstalledPWA = (context, payload) => {
  context.commit("updateInstalledPWA", payload);
};

export const updateNetworkStatus = (context, payload) => {
  context.commit("updateNetworkStatus", payload);
};

export const updatePwaVersion = (context) => {
  context.commit("addNotification", {
    text: "New Version is Available",
    timeout: 15000,
    btn_icon: "$vuetify.icons.update",
    btn_label: "Reload",
    btn_click: (e) => {
      window.location.reload(true);
    }
  });
};


export const notifyError = (context, error) => {
  const msg = error && (error.message || error.response || error.data) || "OOPS.. something went wrong";

  console.log("store.actions.notifyError:", error, msg);

  context.commit("addNotification", {
    text: msg,
    timeout: 5000,
  });
};


export const addActiveRequest = (context) => {
  const requests = context.state.activeRequests + 1;
  context.commit("updateActiveRequests", requests);
};
export const removeActiveRequest = (context) => {
  const requests = context.state.activeRequests > 1 ? context.state.activeRequests - 1 : 0;
  context.commit("updateActiveRequests", requests);
};